import React from 'react';
import { useParams, Link, useNavigate} from "react-router-dom";
import helpers from '../../helpers/helpers';
import images from '../../helpers/images';

function EventCards({data = [], empty_caption = 'Event not found.'}){
    
    function cards(data){
        let card_list = [];

      if (data && data.length > 0) {
          let counter = 1;
          card_list = data.map((data, i) => {
  
              return (
                  <div className='col-lg-4 col-md-6 col-xs-12' key={i}>
                      <div className="card">
                          <img className="card-img-top" src={ helpers.getFileURL(data.image_thumbnail)} alt="Card image cap" />
                          <div className="card-body">
  
                          <div className="mb-4" style={{minHeight: '110px'}}>
                          <h5 className="card-title event-title">{data.title}</h5>
                          <p className="card-text event-subtitle" style={{minHeight: '60px'}}>{data.summary}</p>
                          </div>
  
                          <div className="event-details">
                              <small className="card-event-date">{helpers.displayDateTime(data)}</small>
                          </div>
                          <div className="event-details">
                              {helpers.displayRegistration(data)}
                          </div>
                          {/* <div className="event-details">
                              <small>Restriction Code: 346S234G</small>
                          </div> */}
                          <div className="event-details">
                              <img src={images.locationIcon} alt="location" className="locatioon_icon" />
  
                              {data.venue_type == 'physical' ? (
                                  <small className="mx-2">{data.address}</small>
                              ) : (
                                  <small className="mx-2">Online</small>
                              )}
  
                          </div>
                          
                          {/* status */}
                          {helpers.displayStatus(data)}
  
                          <div className="event-details">
                              {helpers.displayPriceLabel(data)}
                          </div>
                          <h6 className="card-title mt-4 resource">{data.organizer}</h6>
                          <div className="card-show-more mt-3">
                              <Link to={'/e/'+ ((data.slug) ? data.slug: data.id)} className="show-more-link"><small>Show more &gt;</small></Link>
                          </div>
                          </div>
                      </div>
                  </div>
              )
          });
      }else{
          return <div className="text-center p-2">{empty_caption}</div>
      }

      return card_list

    }

    
    return (
        <>
            <div className="row">
                    {cards(data)}
            </div>
        </>
    )
}

export default EventCards;